import { apiClient } from "../../api/client";
import type { Block } from "../../api/types";

// fetchAllBlocks follows the keyset cursor until the season's list is
// exhausted — a single page caps at 100 and the list is newest-first, so
// without the loop the oldest rows (the top blocks) never load and the
// pillar filter has nothing to match. mine narrows it to the caller's own
// blocks (My Blocks).
export async function fetchAllBlocks(season: string, filters: { mine?: boolean } = {}): Promise<Block[]> {
  const blocks: Block[] = [];
  let cursor: string | undefined;
  do {
    const page = await apiClient.listBlocks({ season_id: season, mine: filters.mine, limit: 100, cursor });
    blocks.push(...page.blocks);
    cursor = page.next_cursor;
  } while (cursor !== undefined);
  return blocks;
}
